document.addEventListener("DOMContentLoaded", function () {
  const productData = window.productData;
  const selectedVariantId = window.selectedVariantId;
  console.log(selectedVariantId, "kensium");
  const variantIds = productData.variants.map((variant) => `"${variant.id}"`);
  console.log(variantIds, "variantIds");

  let inventoryData = [];

  function displaySLCStockMessage(variantId) {
    const matched = inventoryData.find((item) => {
      console.log(item.gtin, variantId);
      return item.gtin === variantId;
    });

    const variantValueContainer = document.getElementById("variant-value");
    const distributorQtyContainer = document.getElementById("distributor-quantity");
    const linkContainer = document.getElementById("link-to-slc");
    if (!distributorQtyContainer) {
      console.warn("Message Container is not exists.");
      return;
    }
    if (matched) {
      if (matched.qty > 0) {        
        variantValueContainer.innerHTML = document.querySelector(".product-form__selected-value").textContent;        
        distributorQtyContainer.innerHTML = matched.qty;
        linkContainer.innerHTML = `Please <a href="${matched.product_link}" target="_blank">click here </a> to order.`;
      } else {        
        variantValueContainer.innerHTML = document.querySelector(".product-form__selected-value").textContent;
        distributorQtyContainer.innerHTML = 0;
        linkContainer.innerHTML = `Please <a href="${matched.product_link}" target="_blank">click here </a> to order.`;
      }
    } else {
      variantValueContainer.innerHTML = document.querySelector(".product-form__selected-value").textContent;
      distributorQtyContainer.innerHTML = 0;
      linkContainer.innerHTML = ``;
    }
  }

  const headers = new Headers({
    "Content-Type": "application/json",
  });

  const query = `
        {
            productInventoryByGtin(gtins: [${variantIds.join(",")}]) {
                gtin
                product_link
                qty
                sku
            }
        }
    `;

  const requestOptions = {
    method: "POST",
    headers: headers,
    body: JSON.stringify({ query }),
    redirect: "follow",
  };
  const endpoint = `${window.SLC_DOMAIN}/graphql`;
  fetch(endpoint, requestOptions)
    .then((response) => response.json())
    .then((data) => {
      console.log(data, "kensium");
      if (!data || !data.data || !data.data.productInventoryByGtin) {
        console.warn("Invalid GraphQL response structure", data);
        return;
      }
      console.log(" this is getting ");
      inventoryData = data.data.productInventoryByGtin || [];
      console.log(inventoryData, " kensium");
      displaySLCStockMessage(selectedVariantId);
      console.log("testinf kensium");
      const variantSelector = document.querySelector(
        'form[action^="/cart/add"] [name="id"]'
      );
      console.log(variantSelector, "kensium");

      if (variantSelector) {
        variantSelector.addEventListener("change", function () {
          setTimeout(() => {
            console.log(this.value, "kensium");
            displaySLCStockMessage(this.value);
          }, 50);
        });
      }
    })
    .catch((error) => console.error("GraphQL Error:", error));
});
